import { FC, ReactElement } from 'react';
import NextLink from 'next/link';
import { Link as ChakraLink, Text } from '@chakra-ui/react';
export interface CbClickableElementProps {
  name: string;
  id: number;
  imageUrl?: string;
}
export const CbClickableElement: FC<CbClickableElementProps> = ({
  name,
  id
}): ReactElement => {
  return <NextLink href={`/manage/games/${id}`} data-sentry-element="NextLink" data-sentry-component="CbClickableElement" data-sentry-source-file="CbClickableElement.tsx">
      <ChakraLink color="chonky.500" data-sentry-element="ChakraLink" data-sentry-source-file="CbClickableElement.tsx">
        <Text maxWidth="200px" _hover={{
        textDecoration: 'none'
      }} data-sentry-element="Text" data-sentry-source-file="CbClickableElement.tsx">
          {name}
        </Text>
      </ChakraLink>
    </NextLink>;
};